export default __webpack_public_path__ + "static/media/character1RightArm.01ddc336.webp";